(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["esim-promotion"] && !Shopify.designMode) return;
  try {
    function refreshEsimPromotion(element, now = Date.now()) {
    const start = Date.parse(element.dataset.start);
    const end = Date.parse(element.dataset.end);
    element.hidden = !(now >= start && now < end);
    if (element.hidden) return;
    const seconds = Math.ceil((end - now) / 1000);
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor(seconds % 3600 / 60);
    const remainder = seconds % 60;
    const timer = element.querySelector('[data-promo-countdown]');
    if (timer) timer.textContent = `${hours}h ${String(minutes).padStart(2, '0')}m ${String(remainder).padStart(2, '0')}s`;
    const headline = element.querySelector('[data-promo-headline]');
    if (headline && seconds <= 86400) headline.textContent = element.dataset.finalLabel;
  }
  if (!customElements.get('esim-promotion')) {
    customElements.define('esim-promotion', class extends HTMLElement {
      connectedCallback() { refreshEsimPromotion(this); }
    });
    setInterval(() => {
      const now = Date.now();
      document.querySelectorAll('esim-promotion').forEach(element => refreshEsimPromotion(element, now));
    }, 1000);
  }
  } catch(e) { console.error(e); }
})();

})();
